// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NClXCXPO45nTyjCP4dsF ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.NClXCXPO45nTyjCP4dsF ul li {
  display: inline-block;
}
.NClXCXPO45nTyjCP4dsF ul a {
  background-color: #EBF3FF;
  color: #000000;
  border-radius: 50px;
  font-size: 16px;
  padding: 5px 17px;
  margin: 0 0px 15px 8px;
  display: inline-block;
  transition: 0.3s;
}
.NClXCXPO45nTyjCP4dsF ul a:hover, .NClXCXPO45nTyjCP4dsF ul a.ELXnaoYnHx1Hoz3nbM5F {
  background: #C2DBFD;
}
.NClXCXPO45nTyjCP4dsF ul a span {
  padding-left: 5px;
  color: color-mix(in srgb, var(--default-color), transparent 60%);
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./GeneralComponents/SearchResults/searchFilters/tagsFilter/TagsFilter.module.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AAAJ;AAEI;EACE,qBAAA;AAAN;AAGI;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;AADN;AAGM;EACE,mBAAA;AADR;AAIM;EACE,iBAAA;EACA,gEAAA;EACA,eAAA;AAFR","sourcesContent":[".tags-filter {\r\n  ul {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n\r\n    li {\r\n      display: inline-block;\r\n    }\r\n\r\n    a {\r\n      background-color: #EBF3FF;\r\n      color: #000000;\r\n      border-radius: 50px;\r\n      font-size: 16px;\r\n      padding: 5px 17px;\r\n      margin: 0 0px 15px 8px;\r\n      display: inline-block;\r\n      transition: 0.3s;\r\n\r\n      &:hover, &.selected {\r\n        background: #C2DBFD;\r\n      }\r\n\r\n      span {\r\n        padding-left: 5px;\r\n        color: color-mix(in srgb, var(--default-color), transparent 60%);\r\n        font-size: 14px;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tags-filter": `NClXCXPO45nTyjCP4dsF`,
	"selected": `ELXnaoYnHx1Hoz3nbM5F`
};
export default ___CSS_LOADER_EXPORT___;
